import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import { useTheme } from '@mui/material';

export const Videos = () => {
  const theme = useTheme();

  return (
    <VideoLibraryIcon
      fontSize="medium"
      sx={{ color: theme.palette.tertiary.main }}
    />
  );
};
